import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/UpiSenderAPI';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden, Box } from '@material-ui/core';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import { UPITRANSFER_CODE } from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import UpiBeneficiaryList from './BeneficiaryList';
import { useLocation } from 'react-router-dom';

import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = () => {
    const formRef = useRef();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const location = useLocation();
    const classes = commonStyle();
    const history = useHistory();

    const [senderID, setSenderID] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSenderDetails, setSenderDetails] = useState(false);
    const [isAfterSenderDetails, setAfterSenderDetails] = useState('none');
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(UPITRANSFER_CODE);

    const Mobile = location?.state?.Mobile;
    const [senderNo, setSenderNo] = useState(Mobile ?? '');

    const ActiveUPITransferName = location?.state?.ActiveUPITransferName;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile ?? '',
        Name: '',
        UpiSenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false
    });

    useEffect(() => {
        fetchConsumerNumberFontSize();
    }, []);

    useEffect(() => {
        select();
        fetchSender();
        setLoading(false);
    }, [ActiveUPITransferName]);

    const fetchSender = () => {
        if (formRef === undefined) return;

        if (!formRef.current) return;

        if (formRef.current.values === undefined) return;

        if (formRef.current.values.Mobile === undefined) return;

        if (formRef.current.values.Mobile.length !== 10) return;

        formRef.current.handleSubmit();
    };

    const select = () => {
        let primaryID = Mobile;

        if (primaryID === undefined) return;
        if (primaryID === null) return;

        if (primaryID.length !== 10) return;

        let ActiveUPITransfer = ActiveUPITransferName;
        if (ActiveUPITransfer === undefined) return;
        if (ActiveUPITransfer === null) return;
        if (ActiveUPITransfer === '') return;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            Name: '',
            GUID: '',
            RemainingLimit: ''
        });
    };

    const submitHandle = async (values, { setSubmitting, resetForm }) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            AccountNumber: '',
            UpiSenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderID('');
        setSenderNo('');
        setResponseMessage('');
        var requestObj = JSON.stringify(values);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                UpiSenderID: values.UpiSenderID,
                ActiveUPITransferName: ActiveUPITransferName
            };
            history.push('UPIBeneficiaryAdd', param);
            return;
        }

        setLoading(true);
        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setAfterSenderDetails(false);
        setLoading(false);
        setServiceCode(UPITRANSFER_CODE);
        setSeverity('success');

        var param_2 = {
            Mobile: values.Mobile,
            ActiveUPITransferName: ActiveUPITransferName
        };
        if (!response.status) {
            setSeverity('error');
            if (response.data === 'Sender not registered') {
                history.push('/UPISenderAdd', param_2);
            }

            if (response.data === 'Sender not verified') {
                history.push('/UPISenderVerify', param_2);
            }
            if (
                response.data ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KycIndex');
                return;
            }

            setIsError(true);
            setResponseMessage(response.data);
            return;
        }
        setSenderDetails(true);

        var data = JSON.parse(response.data);

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            UpiSenderID: data.UpiSenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false
        });
        setSenderID(data.UpiSenderID);
        setSenderNo(data.Mobile);
        setLoading(false);
    };

    const FormValidationSchema = Yup.object({
        // Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
                render={({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                font_size={
                                                    consumerNumberFontSize
                                                }
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                placeholder="Mobile"
                                                typed_length={1}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    {isSenderDetails ? (
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={4}
                                                lg={4}
                                            >
                                                <MaterialTextField
                                                    label="Name"
                                                    name="Name"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Name"
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={4}
                                                lg={4}
                                            >
                                                <MaterialTextField
                                                    label="Remaining Limit"
                                                    name="RemainingLimit"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Remaining Limit"
                                                />
                                                <Hidden xsUp>
                                                    <MaterialTextField
                                                        label="UpiSenderID"
                                                        name="UpiSenderID"
                                                        type="text"
                                                        readOnly={true}
                                                        placeholder="SenderID"
                                                    />
                                                </Hidden>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={4}
                                                lg={4}
                                            >
                                                <MaterialTextField
                                                    label="Consumed"
                                                    name="Consumed"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Consumed"
                                                />
                                            </Grid>
                                        </Grid>
                                    ) : null}
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <UpiBeneficiaryList
                senderMobile={senderNo}
                senderName={formObject.Name}
                senderID={senderID}
                ActiveUPITransferName={ActiveUPITransferName}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
            <Last10RechargeReport ServiceID={serviceCode} refreshRandom={1} />
        </CustomContainer>
    );
};
